module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAJpJREFUOE/tkzEKAjEQRd8HD+JBttA7bLO1jTdTECsLt9PDeIyFvyQkkCKE4Fo6TWCG/2Ym+REbQ0Fv+wUcKqy3pGOzngCWFGFl2I75fFbrf4B/8wpbrNA1QatBBjR9UAPY3gGnrwBJfAngLoDtG3CVdC/FwNQLGIAHcAbGtNIkaekCJLsHyBOYY2dpKVdo/sZ8ibb3wCeLQ34FLR22gqdJaqIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/batch-deletion.png
// module id = GEde
// module chunks = 5